//components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
class PermissionEditorPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'rolePermissions';
        this.Server = this.props.context.getState().server.rolePermissions;
        this.Sort = 'role';

        this.MenuDisplayType = 'none';
        this.CheckboxCell = false;
        this.NeedSearch = false;
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'controller',
                label: 'controller',
                alignRight: false,
                cell: 'ItemsControllers',
                filterCell: 'ItemsContext',
                filterBy: 'controllers',
                // translate: 'controllers',
                needStyle: true,
                isSingle: true,
                displayGrid: true,
                disableSort: true,
            },
            {
                id: 'roleId',
                label: 'role',
                show: 'name',
                filterCell: 'Context',
                filterBy: 'roles',
                from: 'roles',
                needStyle: true,
                isSingle: true,
                alignRight: false,
                cell: 'Select',
                object: 'role',
                // translate: 'enums',
                displayGrid: true,
                disableSort: true,
            },
            {
                id: 'read', required: true,
                label: 'read',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true,
                disableSort: true,
            },
            {
                id: 'update', required: true,
                label: 'update',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true,
                disableSort: true,
            },
            {
                id: 'create', required: true,
                label: 'create',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true,
                disableSort: true,
            },
            {
                id: 'delete', required: true,
                label: 'delete',
                alignRight: false,
                cell: 'EditorSelect',
                items: ["allow_all", "allow_own", "deny"],
                displayGrid: true,
                disableSort: true,
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            currentValues: {}
        };
    }

    async retrieveData() {
        await super.retrieveData();
        this.setState(
            (prevState) => ({
                currentValues: this.List.reduce((acc, cur) => {
                    acc[cur.id] = {
                        read: cur.read,
                        update: cur.update,
                        create: cur.create,
                        delete: cur.delete
                    };
                    return acc;
                }, {})
            })
        );
    }

    handleChangeCell = (event, permissionId, cellId) => {
        const { value } = event.target;
        this.setState((prevState) => ({
            currentValues: {
                ...prevState.currentValues,
                [permissionId]: {
                    ...prevState.currentValues[permissionId],
                    [cellId]: value
                }
            }
        }));
    };

    handleSaveCell = async (id, role, controller) => {
        let data = this.state.currentValues[id];
        const newData = { ...data, controller, roleId: role.id };

        if (Object.keys(data).length) {
            await this.Server.update(id, newData);
        }

        this.retrieveData().then(() => this.updatePermissionsData());
    };

    renderCheckboxCell = () => {
        return null;
    };
}

export default PermissionEditorPage;
